export default __webpack_public_path__ + "assets/appstore_bt.15f01eef.svg";